<template>
  <template v-if="btnList.length <= 3">
    <slot v-for="index in 10" :key="index" :name="'bs' + index"> </slot>
  </template>
  <template v-else>
    <slot v-for="item in btnList.slice(0, 2)" :key="item" :name="item"></slot>
    <a-dropdown overlayClassName="btnFoldWrap">
      <span class="fold"><svg-icon iconClass="fold" /></span>
      <template #overlay>
        <a-menu>
          <a-menu-item v-for="o in btnList.slice(2)" :key="o">
            <slot :name="o"></slot>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </template>
</template>

<script setup>
import { useSlots, ref } from "vue";
const slots = useSlots();
const btnList = ref([]);
const list = [];
for (let item in slots) {
  list.push(item);
}
list.sort();
btnList.value = list;
</script>

<style lang="less" scoped>
.fold {
  display: inline-block;
  width: 28px;
  text-align: center;
}
</style>
<style lang="less">
.btnFoldWrap {
  .ant-dropdown-menu-item {
    color: #5e66f2 !important;
    .delete {
      color: #f24949;
    }
  }
}
</style>
